import type { ReactNode } from "react";

/** A home page section's title, with an optional eyebrow above and a link or controls at the right. */
export function SectionHeading({ eyebrow, title, action }: { eyebrow?: string; title: string; action?: ReactNode }) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="mb-2 type-eyebrow tracking-[var(--tracking-widest)] text-green-700 uppercase">{eyebrow}</p>}
        <h2 className="m-0 type-h2 [font-size:var(--text-xl)]">{title}</h2>
      </div>
      {action && <div className="flex-none">{action}</div>}
    </div>
  );
}
